import { useTranslation } from "react-i18next";

import { Card, Col, Row } from "antd";
import { precision } from "../../../utils";
import { DisplayUnits } from "../../SpuChart/displayUnits/definitions";
import {
  formatDiameterDisplayNumber,
  formatDisplayMetricNumber,
  formatPowerDisplayValue
} from "../../SpuChart/displayUnits/displayFormatters";
import {
  convertDiameterFromCanonical,
  convertNpshrFromCanonical,
  convertPowerFromCanonical,
  getDisplayUnitLabel
} from "../../SpuChart/displayUnits/converters";

import './PerformanceResult.css';

const PerformanceResult = ({
  fieldsResult,
  displayUnits
}: any) => {
  const { t } = useTranslation();

  if (!fieldsResult) {
    return <></>;
  }

  const {
    diameter,
    speed,
    frequency,
    power,
    npsh,
    eff,
    diameterUnit
  } = fieldsResult;

  const finalDisplayUnits: DisplayUnits = displayUnits || {
    flow: "m3/h",
    head: "m",
    power: "kW",
    npshr: "m",
    diameter: "mm",
    viscosity: "cSt",
    efficiency: "%"
  };
  const displayPower = convertPowerFromCanonical(power, finalDisplayUnits.power) as number;
  const displayNpsh = convertNpshrFromCanonical(npsh, finalDisplayUnits.npshr) as number;
  const displayDiameter = diameterUnit === "%"
    ? diameter
    : (convertDiameterFromCanonical(diameter, finalDisplayUnits.diameter) as number);
  const displayDiameterUnit = diameterUnit === "%"
    ? "%"
    : getDisplayUnitLabel("diameter", finalDisplayUnits.diameter);

  return (
    <Card className='per-formance-result'>
      <Row gutter={18}>
        <Col span={12}>
          <div className='chart-title'>
            {t("chart.diameter")}
          </div>
          <div className='chart-label'>
            {formatDiameterDisplayNumber(displayDiameter, displayDiameterUnit)}{displayDiameterUnit}
          </div>
          {/* <Statistic
            title={t("chart.diameter")}
            value={diameter}
            precision={0}
            suffix="mm"
          /> */}
        </Col>
        <Col span={12}>
          <div className='chart-title'>
            {t("chart.speed")}
          </div>
          <div className='chart-label'>
            {precision(speed, 0)}rpm
          </div>
          {/* <Statistic
            title={t("chart.speed")}
            value={speed}
            precision={0}
            suffix="rpm"
          /> */}
        </Col>
        <Col span={12}>
          <div className='chart-title'>
            {t("chart.frequency")}
          </div>
          <div className='chart-label'>
            {precision(frequency, 2)}hz
          </div>
          {/* <Statistic
            title={t("chart.frequency")}
            value={frequency}
            precision={2}
            suffix="hz"
          /> */}
        </Col>
        <Col span={12}>
          <div className='chart-title'>
            P
          </div>
          <div className='chart-label'>
            {formatPowerDisplayValue(displayPower)}{getDisplayUnitLabel("power", finalDisplayUnits.power)}
          </div>
        </Col>
        <Col span={12}>
          <div className='chart-title'>
            NPSHr
          </div>
          <div className='chart-label'>
            {formatDisplayMetricNumber("npshr", displayNpsh)}{getDisplayUnitLabel("npshr", finalDisplayUnits.npshr)}
          </div>
          {/* <Statistic title="NPSHr" value={npsh} precision={2} suffix="m" /> */}
        </Col>
        <Col span={12}>
          <div className='chart-title'>
            {t("chart.efficiency")}
          </div>
          <div className='chart-label'>
            {formatDisplayMetricNumber("efficiency", eff)}%
          </div>
          {/* <Statistic
            title={t("chart.efficiency")}
            value={eff}
            precision={2}
            suffix="%"
          /> */}
        </Col>
      </Row>
    </Card>
  );
};

export default PerformanceResult;
